/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZugangDto } from '../../models/zugang-dto';

export interface GetAllZugaenge$Json$Params {
}

export function getAllZugaenge$Json(http: HttpClient, rootUrl: string, params?: GetAllZugaenge$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZugangDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllZugaenge$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ZugangDto>>;
    })
  );
}

getAllZugaenge$Json.PATH = '/v1/zugaenge';
